<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="All clients" name="first"></el-tab-pane>
			<el-tab-pane label="New client" name="second"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>Search client by name, phone or ID</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-30">
					<md-field>
						<label>Gender</label>
						<md-select placeholder="Gender (All)" v-model="search.gender">
							<md-option value="">All</md-option>
							<md-option value="f">Female</md-option>
							<md-option value="m">Male</md-option>
							<md-option value="o">Other</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-size-30">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">Search
					</md-button>
				</div>
			</div>

			<md-table v-if="clientList.length > 0">
				<md-table-row>
					<md-table-head>N.o</md-table-head>
					<md-table-head>Client ID</md-table-head>
					<md-table-head>Name</md-table-head>
					<md-table-head>Gender</md-table-head>
					<md-table-head>Phone</md-table-head>
					<md-table-head>Total Loan Amount</md-table-head>
					<md-table-head>Created Date</md-table-head>
					<md-table-head>Action</md-table-head>
				</md-table-row>

				<md-table-row v-for="(client, index) in clientList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>
						<img src="@/assets/img/default-member.png" style="width: 34px; margin-right:5px">
						{{ client.hash_id }}
					</md-table-cell>
					<md-table-cell>{{ client.name }}<br>{{client.name_khmer}}</md-table-cell>
					<md-table-cell>{{ config.getGender(client.gender) }}</md-table-cell>
					<md-table-cell>{{ client.phone }}</md-table-cell>
					<md-table-cell>
						<b v-if="client.total_loan != null">{{config.moneylify(client.total_loan_amount)}}
							({{client.total_loan}})</b>
						<b v-else>$0.00 (0)</b>
					</md-table-cell>
					<md-table-cell>{{ config.datelify(client.created_date) }}</md-table-cell>
					<md-table-cell>
						<router-link :to="'/clients/detail/' + client.hash_id">
							<md-button class="md-just-icon md-simple md-success">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">View this client</md-tooltip>
							</md-button>
						</router-link>
						<router-link :to="'clients/edit/'+ client.hash_id">
							<md-button class="md-just-icon md-simple md-info">
								<md-icon>edit</md-icon>
								<md-tooltip md-direction="top">Edit client information</md-tooltip>
							</md-button>
						</router-link>

						<md-button class="md-just-icon md-simple md-danger" @click="showDeleteAction(client.id)">
							<md-icon>close</md-icon>
							<md-tooltip md-direction="top">Delete this client</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>

			<h4 class="text-center" v-if="clientList.length == 0 && loadMore == true">No client data.</h4>
			<!-- <div class="places-buttons text-center" v-if="loadMoreCompanyButton" >
				<md-button class="md-primary" @click="getCompany(companyList.length, false)">បង្ហាញបន្ថែម</md-button>
			</div> -->
		</div>



		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>Client Information</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* required</span>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Client Name *</label>
								<md-input type="text" v-model="client.name"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Client Khmer Name *</label>
								<md-input type="text" v-model="client.name_khmer"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Gender *</label>
								<md-select placeholder="Gender *" v-model="client.gender">
									<md-option value="f">Female</md-option>
									<md-option value="m">Male</md-option>
									<md-option value="o">Other</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Date of Birth *</label>
								<md-input type="text" v-model="client.dob"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>Client Phone *</label>
								<md-input type="text" v-model="client.phone"></md-input>
							</md-field>
						</div>

						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>ID Card Number *</label>
								<md-input type="text" v-model="client.id_card"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Occupation *</label>
								<md-input type="text" v-model="client.occupation"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>Address</label>
								<md-input type="text" v-model="client.address">
								</md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>Client Note</label>
								<md-input type="text" v-model="client.note">
								</md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-size-100 file-image"
							style="text-align: center;">
							<div class="file-image-wrapper">
								<h6>ID Card Photo</h6>
								<div class="md-layout-item md-small-size-100 md-size-100" style="min-height: 150px;">
									<input type="file" ref="id_card" accept="image/*" style="display: none;"
										@change="processFile($event, 'id_card')">
									<img class="thumb-product" src="/id-card.png" v-if="client.image_url.length == 0">
									<img class="thumb-product" :src="client.image_url" v-if="client.image_url.length > 12">
									<img class="thumb-product" :src="config.getImageUrl(client.image_url)"
										v-if="client.image_url.length == 12">
								</div>
								<md-button class="md-primary" @click="openImage('id_card')" v-if="client.image_url.length == 0">
									Upload
								</md-button>
								<md-button class="md-primary" @click="removeImage('id_card')" v-else>
									Remove</md-button>
							</div>
						</div>
					</div>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>Summary</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 50%;">Client Name</md-table-cell>
								<md-table-cell style="width: 5px">:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.name).length > 0">{{client.name}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Client Khmer Name</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.name_khmer).length > 0">{{client.name_khmer}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Gender</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.gender).length > 0 && client.gender == 'm'">Male</span>
									<span v-else-if="String(client.gender).length > 0 && client.gender == 'f'">Female</span>
									<span v-else-if="String(client.gender).length > 0 && client.gender == 'o'">Other</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Date of Birth</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.dob).length > 0">{{client.dob}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Occupation</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.occupation).length > 0">{{client.occupation}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Client Phone</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.phone).length > 0">{{client.phone}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>ID Card</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.id_card).length > 0">{{client.id_card}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Address</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.address).length > 0">{{client.address}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Client Note</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.note).length > 0">{{client.note}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="postClient()">Create</md-button>
				</div>
			</div>

		</div>
		<md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="Are you sure want to delete this client ?"
			md-content="This client will be deleted and can't be restored" md-confirm-text="Delete" md-cancel-text="Cancel"
			@md-cancel="onCancel" @md-confirm="onDelete" />
	</div>
	</div>



</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					text: "",
					gender: ""
				},
				client: {
					valid: false,
					name: "",
					name_khmer: "",
					phone: "",
					gender: "",
					note: "",
					dob: "",
					occupation: "",
					address: "",
					id_card: "",
					image_url: ""
				},
				loadMore: true,
				clientList: []

			}
		},
		methods: {
			postClient() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/client/post", {
					client: this.client
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "Client was created successfully.",
							icon: 'done',
							type: 'success'
						});
						this.search.text = "";
						this.search.gender = "";
						this.searchHandler();
					}
					// this.loadMoreCompanyButton = true
					// this.memberList = data.body.data;
				})
			},
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/client/search", {
					text: this.search.text,
					gender: this.search.gender,
					offset: more ? this.clientList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					this.clientList = data.body.data;
				})
			},
			checkValidation() {
				if (String(this.client.name).length > 0 && String(this.name_khmer).length > 0
					&& String(this.client.phone).length > 0 && String(this.client.gender).length > 0
					&& String(this.client.dob) && String(this.client.id_card) && String(this.client.occupation)
					&& String(this.client.image_url).length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "Please fill in information.",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},
			clearAll() {
				this.search.text = "";
				this.search.gender = "";
				this.client = {
					valid: false,
					name: "",
					name_khmer: "",
					phone: "",
					gender: "",
					note: "",
					dob: "",
					occupation: "",
					address: "",
					id_card: ""
				}
			},
			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete() {
				this.$http.post(this.config.api + "/admin/client/delete", {
					id: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "This client was deleted successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.deleteDialogActive = false
			},
			processFile(e, file) {
				let files = e.target.files || e.dataTransfer.files;
				if (!files.length) return;

				this.client.image_url = "/loading-image.gif";;
				let formData = new FormData();

				formData.append("image_id", files[0], files[0].name);
				var self = this;
				this.$http.post(this.config.api + '/admin/file/upload', formData, {
					// progress(e) {
					// 	if (e.lengthComputable) {
					// 		let progress = parseInt(e.loaded / e.total * 100);
					// 		self.progress[file].show = true
					// 		self.progress[file].value = progress
					// 	}
					// }
				}).then(res => {
					if (res.body.status == 'success') {
						// this.progress[file].show = false;
						this.client.image_url = res.body.data.id
						// this.checkValidation();
					} else {
						this.client.image_url = ""
					}
				})
			},
			openImage(id) {
				this.$refs[id].click();
			},
			removeImage(id) {
				this.client.image_url = "";
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
	.file-image-wrapper {
		/* margin: 10px; */
		width: calc(100%);
		padding-top: 8px;
		padding-bottom: 5px;
		border: 1px solid #ccc;
		border-radius: 5px;
	}

	.file-image {
		margin-top: 21px;
		text-align: center;
		/* margin-left: 10px;
		margin-right: 10px; */
		/* min-width: calc(33.3333% - 20px) !important;
		max-width: calc(33.3333% - 20px) !important;
		flex: 0 1 calc(33.3333% - 20px) !important; */
		/* padding: 0; */
	}
</style>



// WEBPACK FOOTER //
// src/pages/Clients/View.vue